import { render, staticRenderFns } from "./shagnchuan.vue?vue&type=template&id=7017938a&scoped=true"
import script from "./shagnchuan.vue?vue&type=script&lang=js"
export * from "./shagnchuan.vue?vue&type=script&lang=js"
import style0 from "./shagnchuan.vue?vue&type=style&index=0&id=7017938a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7017938a",
  null
  
)

export default component.exports